import { ProfileDetailsType } from "./ProfileDetailsType"

export type PieAnalysisType = Pick<ProfileDetailsType, 
"analysisFlag" |
"analysisReviewedBy" |
"analysisReviewedDate">

export const initialPieAnalysis: PieAnalysisType = {
  analysisFlag: "X", // anaylsis default to X
  analysisReviewedBy: "SYSTEM", // audit field
  analysisReviewedDate: (new Date().toISOString())
}

export const keysOfPieAnalysisType: (keyof PieAnalysisType)[] = [
  "analysisFlag",
  "analysisReviewedBy",
  "analysisReviewedDate"
];